var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportViewPage',{key:_vm.reporttype,attrs:{"source":_vm.companyId,"type":_vm.reporttype,"path":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }